export default __webpack_public_path__ + "static/media/Software-Papel-Comercial.baafdc8a.webp";